module.exports = __webpack_public_path__ + "static/media/logoTmave.43c226ce.png";